import React, { useMemo } from "react";

const CHART = {
  size: 240,
  radius: 88,
  stroke: 34,
};

export default function TestUsageDonutChart({ usage, loading }) {
  const items = usage?.items || [];
  const total = usage?.total || 0;

  const segments = useMemo(() => {
    if (total === 0) return [];

    const circumference = 2 * Math.PI * CHART.radius;
    let offset = 0;

    return items.map((item) => {
      const length = (item.count / total) * circumference;
      const segment = {
        ...item,
        dashArray: `${length} ${circumference - length}`,
        dashOffset: -offset,
      };
      offset += length;
      return segment;
    });
  }, [items, total]);

  const center = CHART.size / 2;
  const topTest = items[0];

  return (
    <section className="dashboard-donut-section">
      <header className="dashboard-donut-header">
        <h2 className="dashboard-donut-title">
          Las pruebas más aplicadas en la clínica
        </h2>
        <p className="dashboard-donut-subtitle">
          Conteo global de instrumentos de evaluación utilizados en la consulta
          habitual
          {topTest
            ? `. La más frecuente es ${topTest.testName} con ${topTest.count} aplicaciones.`
            : "."}
        </p>
      </header>

      {loading ? (
        <p className="dashboard-donut-empty">Cargando uso de pruebas...</p>
      ) : total === 0 ? (
        <p className="dashboard-donut-empty">
          Aún no hay pruebas registradas para mostrar la distribución por
          instrumento.
        </p>
      ) : (
        <div className="dashboard-donut-body">
          <div className="dashboard-donut-chart-wrap">
            <svg
              viewBox={`0 0 ${CHART.size} ${CHART.size}`}
              className="dashboard-donut-chart"
              role="img"
              aria-label="Distribución de pruebas más aplicadas"
            >
              <circle
                cx={center}
                cy={center}
                r={CHART.radius}
                className="dashboard-donut-track"
                strokeWidth={CHART.stroke}
              />
              {segments.map((segment) => (
                <circle
                  key={segment.testName}
                  cx={center}
                  cy={center}
                  r={CHART.radius}
                  fill="none"
                  stroke={segment.color}
                  strokeWidth={CHART.stroke}
                  strokeDasharray={segment.dashArray}
                  strokeDashoffset={segment.dashOffset}
                  transform={`rotate(-90 ${center} ${center})`}
                  className="dashboard-donut-segment"
                >
                  <title>{`${segment.testName}: ${segment.count} (${segment.percentage}%)`}</title>
                </circle>
              ))}
            </svg>
            <div className="dashboard-donut-center">
              <strong>{total}</strong>
              <span>Pruebas</span>
            </div>
          </div>

          <ul className="dashboard-donut-legend">
            {items.map((item) => (
              <li key={item.testName} className="dashboard-donut-legend-item">
                <span
                  className="dashboard-donut-legend-swatch"
                  style={{ backgroundColor: item.color }}
                  aria-hidden="true"
                />
                <div className="dashboard-donut-legend-copy">
                  <span className="dashboard-donut-legend-name">
                    {item.testName}
                  </span>
                  <span className="dashboard-donut-legend-meta">
                    {item.count} ({item.percentage}%)
                  </span>
                </div>
              </li>
            ))}
          </ul>
        </div>
      )}
    </section>
  );
}
